import translate from '@/services/translate';
import UserService from '@/services/user';

function filterAllowedSelfDiagnosisDefinition(def) {
  return UserService.hasPermission('PER014') ? [def] : [];
}

const networkStatusHistoryTableFields = () => [
  {
    key: 'dateTime',
    label: translate('reports.network-status.fields.date-and-time'),
  },
  {
    key: 'companyName',
    label: translate('reports.network-status.fields.company'),
  },
  {
    key: 'regionalName',
    label: translate('reports.network-status.fields.regional'),
  },
  {
    key: 'installationName',
    label: translate('reports.network-status.fields.installation'),
  },
  {
    key: 'assetName',
    label: translate('reports.network-status.fields.asset'),
  },
  {
    key: 'assetSerialNumber',
    label: translate('reports.network-status.fields.serial-number'),
  },
  {
    key: 'moduleName',
    label: translate('reports.network-status.fields.module'),
  },
  {
    key: 'moduleStatus',
    label: translate('reports.network-status.fields.module-status'),
  },
  {
    key: 'ip',
    label: translate('reports.network-status.fields.ip'),
  },
  {
    key: 'address',
    label: translate('reports.network-status.fields.address'),
  },
  {
    key: 'networkStatus',
    label: translate('reports.network-status.fields.network-status'),
  },
  ...filterAllowedSelfDiagnosisDefinition({
    key: 'moduleSelfDiagnosisStatus',
    label: translate('reports.network-status.fields.module-self-diagnosis-status'),
  }),
];

export default networkStatusHistoryTableFields;
